// courses actions
export const COURSES_FETCH_START = 'COURSES_FETCH_START';
export const COURSES_FETCH_SUCCESS = 'COURSES_FETCH_SUCCESS';
export const COURSES_FETCH_FAILURE = 'COURSES_FETCH_FAILURE';
export const COURSES_LOAD_START = 'COURSES_LOAD_START';
export const COURSES_LOAD_SUCCESS = 'COURSES_LOAD_SUCCESS';
export const COURSES_LOAD_FAILURE = 'COURSES_LOAD_FAILURE';
export const RESET_COURSES = 'RESET_COURSES';
// free courses actions
export const COURSES_FREE_FETCH_START = 'COURSES_FREE_FETCH_START';
export const COURSES_FREE_FETCH_SUCCESS = 'COURSES_FREE_FETCH_SUCCESS';
export const COURSES_FREE_FETCH_FAILURE = 'COURSES_FREE_FETCH_FAILURE';
export const COURSES_FREE_LOAD_START = 'COURSES_FREE_LOAD_START';
export const COURSES_FREE_LOAD_SUCCESS = 'COURSES_FREE_LOAD_SUCCESS';
export const COURSES_FREE_LOAD_FAILURE = 'COURSES_FREE_LOAD_FAILURE';
// paid courses actions
export const COURSES_PAID_FETCH_START = 'COURSES_PAID_FETCH_START';
export const COURSES_PAID_FETCH_SUCCESS = 'COURSES_PAID_FETCH_SUCCESS';
export const COURSES_PAID_FETCH_FAILURE = 'COURSES_PAID_FETCH_FAILURE';
export const COURSES_PAID_LOAD_START = 'COURSES_PAID_LOAD_START';
export const COURSES_PAID_LOAD_SUCCESS = 'COURSES_PAID_LOAD_SUCCESS';
export const COURSES_PAID_LOAD_FAILURE = 'COURSES_PAID_LOAD_FAILURE';
// featured courses actions
export const COURSES_FEATURED_FETCH_START = 'COURSES_FEATURED_FETCH_START';
export const COURSES_FEATURED_FETCH_SUCCESS = 'COURSES_FEATURED_FETCH_SUCCESS';
export const COURSES_FEATURED_FETCH_FAILURE = 'COURSES_FEATURED_FETCH_FAILURE';
export const COURSES_FEATURED_LOAD_START = 'COURSES_FEATURED_LOAD_START';
export const COURSES_FEATURED_LOAD_SUCCESS = 'COURSES_FEATURED_LOAD_SUCCESS';
export const COURSES_FEATURED_LOAD_FAILURE = 'COURSES_FEATURED_LOAD_FAILURE';
// courses filter actions
export const COURSES_FILTER_CATEGORY_SET = 'COURSES_FILTER_CATEGORY_SET';
export const COURSES_QUERY_TEXT_SET = 'COURSES_QUERY_TEXT_SET';
export const SET_FEATURED_INSTITUTIONS_FILTER =
  'SET_FEATURED_INSTITUTIONS_FILTER';
export const RESET_FEATURED_INSTITUTIONS_FILTER =
  'RESET_FEATURED_INSTITUTIONS_FILTER';
export const COURSES_MYCOURSES_QUERY_TEXT_SET =
  'COURSES_MYCOURSES_QUERY_TEXT_SET';
export const FEED_SEARCH_BAR_USER_INPUT = 'FEED_SEARCH_BAR_USER_INPUT';
// current course path
export const COURSE_PATH_SET = 'COURSE_PATH_SET';
export const RESET_COURSES_FILTERS = 'RESET_COURSES_FILTERS';
